import React, { useContext, useEffect, useState } from 'react'
import { HrmStore } from '../../Context/HrmContext'
import axios from 'axios'
import { port } from '../../App'
import { useParams } from 'react-router-dom'
import InterviewDataSection from '../../Components/ActivityComponents/InterviewDataSection'

const InterviewPage = ({ emyid }) => {
    let { setTopNav } = useContext(HrmStore)
    let { empid: paramEmpId } = useParams()
    
    // Resolve empid using URL params, prop, or sessionStorage fallback
    const loggedIn = JSON.parse(sessionStorage.getItem('user'));
    const loggedInEmpId = loggedIn?.EmployeeId || JSON.parse(sessionStorage.getItem('dasid'));
    const empid = paramEmpId || emyid || loggedInEmpId;

    // let [interviewData, setInterviewData] = useState()
    const current_date = new Date();
    const [month, setMonth] = useState(current_date.getMonth());
    const [year, setYear] = useState(current_date.getFullYear());

    let getinterviewData = () => {
        // axios.get(`${port}/root/display-interviewcalls-date?login_emp_id`).then((response) => {
        if (!empid) return;
        axios.get(`${port}/root/display-interviewcalls-date?login_emp_id=${empid}`).then((response) => {
            console.log(response.data);

        }).catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        if (empid) {
            getinterviewData()
        }
        setTopNav('interview')
    }, [empid])
    return (
        <div>
            {/* <InterviewDataSection/> */}
            <InterviewDataSection empid={empid} month={month} year={year} dates={[]} />

        </div>
    )
}

export default InterviewPage